export function getImageTrackingValue(trackingLabel: string) {
    switch (trackingLabel) {
        case "logo":
            return "top image"
        case "profile":
            return "profile"
        case "banner":
            return "bottom image"
    }
}
